module.exports = __webpack_public_path__ + "static/media/werewolf.1a596fd2.svg";